import React, { lazy, Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';


import './index.css';
import './styles/NewStyles.css';
import App from './App';
import HomePage from './pages/HomePage';
import ExamPage from './pages/ExamPage';
import MockTestPage from './pages/MockTestPage';
import ResultsPage from './pages/ResultsPage';
import reportWebVitals from './reportWebVitals';
import LoginPage from './pages/LoginPage';
import SignupPage from './pages/SignupPage';
import DataUploadPage from './pages/DataUploadPage';
import ComingSoon from './components/ComingSoon';

import { AptitudeHomePage } from './pages/Aptitude/HomePage';

import BlogPostPage from './Blog/pages/BlogPost';
import BlogListPage from './Blog/pages/BlogList';




import { Tools } from './pages/tools/Tools';
import { ExternalCalculators } from './pages/tools/ExternalCalculators';
import { SATCalculator } from './pages/tools/SATCalculator';
import { ACTCalculator } from './pages/tools/ACTCalculator';
import { APCalculator } from './pages/tools/APCalculator';
import { APUSHCalculator } from './pages/tools/ap/APUSHCalculator';
import { APLangCalculator } from './pages/tools/ap/APLangCalculator';
import { APBioCalculator } from './pages/tools/ap/APBioCalculator';
import { APChemCalculator } from './pages/tools/ap/APChemCalculator';
import { APLitCalculator } from './pages/tools/ap/APLitCalculator';
import { APGovCalculator } from './pages/tools/ap/APGovCalculator';
import { APPhysicsCalculator } from './pages/tools/ap/APPhysicsCalculator';
import { APPsychCalculator } from './pages/tools/ap/APPsychCalculator';
import { APCalcABCalculator } from './pages/tools/ap/APCalcABCalculator';
import { APCalcBCCalculator } from './pages/tools/ap/APCalcBCCalculator';
import { APWorldCalculator } from './pages/tools/ap/APWorldCalculator';
import { APCSACalculator } from './pages/tools/ap/APCSACalculator';
import { APEuroCalculator } from './pages/tools/ap/APEuroCalculator';
import { APMacroCalculator } from './pages/tools/ap/APMacroCalculator';
import { APPhysics1Calculator } from './pages/tools/ap/APPhysics1Calculator'; 
import { APPhysicsCCalculator } from './pages/tools/ap/APPhysicsCCalculator';
import { APCSPCalculator } from './pages/tools/ap/APCSPCalculator';


import About from './pages/About';
import Terms from './pages/Terms';
import Privacy from './pages/Privacy';


const ArticlesHomePage = lazy(() => import('./pages/Articles/Home'));
const ArticlesCategoryPage = lazy(() => import('./pages/Articles/Category'));
const ArticlesExamPage = lazy(() => import('./pages/Articles/Exam'));
const ArticlesArticlePage = lazy(() => import('./pages/Articles/Article'));

// Simple loading component
const LoadingFallback = () => (
  <div className="flex items-center justify-center min-h-screen">
    <div className="animate-pulse">
      <div className="h-8 w-64 bg-gray-200 rounded mb-4"></div>
      <div className="h-4 w-48 bg-gray-200 rounded"></div>
    </div>
  </div>
);

const router = createBrowserRouter([
  {
    path: '/',
    element: <App />,
    children: [
      { index: true, element: <HomePage /> },
      { path: 'region/:country', element: <HomePage /> },
      { path: 'exam/:examId', element: <ExamPage /> },
      { path: 'mocktest/:examId/:testId', element: <MockTestPage /> },
      { path: 'results/:testId', element: <ResultsPage /> },
      { path: 'login', element: <LoginPage /> },
      { path: 'signup', element: <SignupPage /> },
      { path: 'aptitude', element: <AptitudeHomePage /> },
      { path: 'quantitative-aptitude-questions', element: <AptitudeHomePage /> },
      { path: 'dataupload', element: <DataUploadPage /> },
      { path: 'comingsoon', element: <ComingSoon /> },
      {
        path: 'articles',
        children: [
          { 
            path: 'region/:country', 
            element: <Suspense fallback={<LoadingFallback />}>
              <ArticlesHomePage />
            </Suspense> 
          },
          { 
            path: ':examId', 
            element: <Suspense fallback={<LoadingFallback />}>
              <ArticlesExamPage />
            </Suspense> 
          },
          {
            path: ':examId/:categorySlug', 
            element: <Suspense fallback={<LoadingFallback />}>
              <ArticlesCategoryPage />
            </Suspense> 
          },
          {
            path: ':examId/:categorySlug/:articleSlug', 
            element: <Suspense fallback={<LoadingFallback />}>
              <ArticlesArticlePage />
            </Suspense> 
          },
          { 
            index: true, 
            element: <Suspense fallback={<LoadingFallback />}>
              <ArticlesHomePage />
            </Suspense> 
          }
        ]
      },
      {path: 'about', element: <About /> },
      {path: 'terms', element: <Terms /> },
      {path: 'privacy', element: <Privacy /> },
      {path: 'blog', element: <BlogListPage /> },
      {path: 'blog/:slug', element: <BlogPostPage /> },
      {
        path: 'tools',
        children: [
          { index: true, element: <Tools /> },
          { path: 'external-calculators', element: <ExternalCalculators /> },
          { path: 'sat-score-calculator', element: <SATCalculator /> },
          { path: 'act-score-calculator', element: <ACTCalculator /> },
          { 
            path: 'apush-score-calculator', 
            element: <APUSHCalculator />,
            loader: () => {
              import('./pages/tools/ap/APUSHCalculator');
              return null;
            }
          },
          { 
            path: 'ap-lang-score-calculator', 
            element: <APLangCalculator />,
            loader: () => {
              import('./pages/tools/ap/APLangCalculator');
              return null;
            }
          },
          {
            path: 'ap-bio-score-calculator', 
            element: <APBioCalculator />,
            loader: () => {
              import('./pages/tools/ap/APBioCalculator');
              return null;
            }
          },
          { 
            path: 'ap-chem-score-calculator', 
            element: <APChemCalculator />,
            loader: () => {
              import('./pages/tools/ap/APChemCalculator');
              return null;
            }
          },
          { 
            path: 'ap-lit-score-calculator', 
            element: <APLitCalculator />,
            loader: () => {
              import('./pages/tools/ap/APLitCalculator');
              return null;
            }
          },
          { 
            path: 'ap-gov-score-calculator', 
            element: <APGovCalculator />,
            loader: () => {
              import('./pages/tools/ap/APGovCalculator');
              return null;
            }
          },
          { 
            path: 'ap-psych-score-calculator', 
            element: <APPsychCalculator />,
            loader: () => {
              import('./pages/tools/ap/APPsychCalculator');
              return null;
            }
          },
          { 
            path: 'ap-calc-ab-score-calculator', 
            element: <APCalcABCalculator />,
            loader: () => {
              import('./pages/tools/ap/APCalcABCalculator');
              return null;
            }
          },
          { 
            path: 'ap-calc-bc-score-calculator', 
            element: <APCalcBCCalculator />,
            loader: () => {
              import('./pages/tools/ap/APCalcBCCalculator');
              return null;
            }
          },
          { 
            path: 'ap-world-score-calculator', 
            element: <APWorldCalculator />,
            loader: () => {
              import('./pages/tools/ap/APWorldCalculator');
              return null;
            }
          },
          { 
            path: 'ap-physics-score-calculator', 
            element: <APPhysicsCalculator />,
            loader: () => {
              import('./pages/tools/ap/APPhysicsCalculator');
              return null;
            }
          },
          { 
            path: 'ap-csa-score-calculator', 
            element: <APCSACalculator />,
            loader: () => {
              import('./pages/tools/ap/APCSACalculator');
              return null;
            }
          },
          { 
            path: 'ap-euro-score-calculator', 
            element: <APEuroCalculator />,
            loader: () => {
              import('./pages/tools/ap/APEuroCalculator');
              return null;
            }
          },
          { 
            path: 'ap-macro-score-calculator', 
            element: <APMacroCalculator />,
            loader: () => {
              import('./pages/tools/ap/APMacroCalculator');
              return null;
            }
          },
          { 
            path: 'ap-physics-1-score-calculator', 
            element: <APPhysics1Calculator />,
            loader: () => {
              import('./pages/tools/ap/APPhysics1Calculator');
              return null;
            }
          },
          { 
            path: 'ap-physics-c-score-calculator', 
            element: <APPhysicsCCalculator />,
            loader: () => {
              import('./pages/tools/ap/APPhysicsCCalculator');
              return null;
            }
          },
          { 
            path: 'ap-csp-score-calculator', 
            element: <APCSPCalculator />,
            loader: () => {
              import('./pages/tools/ap/APCSPCalculator');
              return null;
            }
          }
        ]
      },
    ],
  },
]);

// Analytics tracking - only in production
if (process.env.NODE_ENV === 'production') {
  router.subscribe((location) => {
    if (window.gtag) {
      window.gtag('config', 'G-JJCSJTPZ4V', {
        page_path: location.pathname + location.search
      });
    }
  });
}

// Create root and render app
const root = ReactDOM.createRoot(document.getElementById('root'));

// Remove StrictMode in production to avoid double-rendering
if (process.env.NODE_ENV === 'production') {
  root.render(<RouterProvider router={router} />);
} else {
  root.render(
    <React.StrictMode>
      <RouterProvider router={router} />
    </React.StrictMode>
  );
}

// Only measure web vitals in development
if (process.env.NODE_ENV !== 'production') {
  reportWebVitals();
}
